import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'

import { AddPointGroupDialogDataProps, MapFormValues } from '@pages/MapCreateOrEdit/types'

import { useLazyFetchMapConfigByIdQuery } from '@redux/api'

import { convertResponseToFormData, getDefaultValues } from '../helpers'

import { useHandlers } from './useHandlers'
import { useInputs } from './useInputs'

export const useMapCreateOrEdit = () => {
  const { id: mapConfigId } = useParams()

  const methods = useForm<MapFormValues>({ defaultValues: getDefaultValues() })

  const { watch, reset } = methods

  const watchId = watch('id')
  const watchPointGroups = watch('pointGroups')

  const [fetchMapConfigById] = useLazyFetchMapConfigByIdQuery()

  const [showAddPointGroupDialog, setShowAddPointGroupDialog] = useState(false)
  const [addPointGroupDialogData, setAddPointGroupDialogData] = useState<
    AddPointGroupDialogDataProps | undefined
  >()
  const [isLoadingConfig, setIsLoadingConfig] = useState(true)

  const { data, handlers, state } = useHandlers({
    methods,
    setShowAddPointGroupDialog,
    setAddPointGroupDialogData,
  })

  const inputs = useInputs({ isEdit: Boolean(watchId) })

  useEffect(() => {
    if (!isNaN(Number(mapConfigId))) {
      fetchMapConfigById({ id: Number(mapConfigId) })
        .unwrap()
        .then(resp => {
          if (resp) {
            const formData = convertResponseToFormData(resp)

            reset(formData)
          }
        })
        .finally(() => {
          setIsLoadingConfig(false)
        })

      return
    }

    setIsLoadingConfig(false)
  }, [mapConfigId])

  return {
    data,
    state: {
      ...state,
      showAddPointGroupDialog,
      addPointGroupDialogData,
      watchPointGroups,
      watchId,
      isLoadingConfig,
    },
    handlers,
    inputs,
  }
}
